export const mapTables = tempDiv => {
  const getTables = tempDiv.querySelectorAll('.table-input');

  if (getTables?.length > 0) {
    [...getTables].forEach(getTab => {
      const parentEl = getTab.parentElement;
      const thead = getTab.getElementsByTagName('thead');

      [...thead].forEach(head => {
        const theads = head.querySelectorAll('th');
        [...theads].forEach(el => {
          if (!el.style.backgroundColor) {
            el.style.backgroundColor = '#F2F2F2';
          }
        });
      });
      if (parentEl.tagName.toLowerCase() === 'figure') {
        parentEl.removeAttribute('class');
        parentEl.setAttribute('class', 'table');
        parentEl.innerHTML = '';
        parentEl.appendChild(getTab);
        //removing resisers from table
        const resiser = parentEl.querySelectorAll('.ck-table-column-resizer');
        resiser?.length > 0 && resiser?.forEach(item => item?.remove());
      }
    });
  }
};
